import { useAdoptedTools } from "./useMarketplace";

/** Slug of the marketplace tool that unlocks AlchelyMeeting. */
export const ALCHELY_MEETING_TOOL_SLUG = "alchely-meeting";

/**
 * Whether this therapist may hold calls in Alchely.
 *
 * The API gates the tokens on the same adoption, so this only decides what is
 * offered — a therapist who has not taken the tool cannot start a call by
 * reaching the endpoint directly either.
 *
 * Defaults to false while the query is in flight: briefly hiding an option is
 * recoverable, offering one that will be refused is not.
 */
export function useAlchelyMeetingAdopted(): boolean {
    const { data } = useAdoptedTools();
    return (data ?? []).some((tool) => tool.slug === ALCHELY_MEETING_TOOL_SLUG);
}
